import React from "react";

const sizes = {
  sm: "h-5 w-5 border-2",
  md: "h-8 w-8 border-2",
  lg: "h-12 w-12 border-4",
};

const AppLoader = ({ text, size = "md", className = "" }) => {
  let color = "#3b82f6";

  try {
    const theme = JSON.parse(sessionStorage.getItem("vendorTheme") || "{}");
    color = theme?.theme?.color_shades?.["500"] || color;
  } catch {
    // use default color
  }

  return (
    <div className={`flex flex-col items-center justify-center gap-2 py-4 ${className}`}>
      <div
        className={`${sizes[size] || sizes.md} rounded-full border-gray-200 animate-spin`}
        style={{ borderTopColor: color }}
      />
      {text ? <p className="text-sm text-gray-500">{text}</p> : null}
    </div>
  );
};

export default AppLoader;
